import { useEffect } from 'react';

function useDisableScroll() {
    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, []);
}

export default useDisableScroll;